import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild,} from '@angular/core';
import {Router} from '@angular/router';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {PspTypeEnum} from 'src/app/enums/psp-type.enum';
import {showNotification} from 'src/app/helpers/show-toast';
import {PatientAddress, PatientSubscription,} from 'src/app/_models/patient.model';
import {PatientService} from 'src/app/_services/patient.service';
import {PspSubscriptionStatusEnum} from 'src/app/enums/psp-subscription-status-enum';
import {FlagSubscriptionModalComponent} from '../flag-subscription-modal/flag-subscription-modal.component';
import {PspSubscriptionService} from '../../../_services/PSP/psp-subscription.service';
import {PspCompanyEnum} from '../../../enums/psp-company.enum';
import { SubscriptionHistoryModalComponent } from '../subscription-history-modal/subscription-history-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreviewDocumentsModalComponent } from '@components/preview-documents-modal/preview-documents-modal.component';
import { UploadMultipleFilesModalComponent } from '@components/upload-multiple-files-modal/upload-multiple-files-modal.component';

@Component({
  selector: 'app-patient-subscriptions',
  templateUrl: './patient-subscriptions.component.html',
  styleUrls: ['./patient-subscriptions.component.scss'],
})
export class PatientSubscriptionsComponent implements OnInit {
  patient: any;
  @Input() patientId: number;
  @Input() addresses: PatientAddress[];
  @Output() addNewAddress = new EventEmitter<any>();
  @ViewChild('otpModal') otpModal: TemplateRef<any>;
  otp;
  notificationModal: BsModalRef;
  addAddressForm = {
    keyboard: true,
    class: 'modal-dialog-centered modal-black',
  };
  moreMenuItems = {} as {
    pending: {};
    active: {};
    previous: {};
  };
  subscriptionArray = {} as {
    pending: PatientSubscription[];
    active: PatientSubscription[];
    previous: PatientSubscription[];
  };
  isHaveCareGiverSubscription: boolean;
  currentPspType: number = PspTypeEnum.PspPatient;
  allSubscriptions: PatientSubscription[];
  pspTypeEnum = PspTypeEnum;
  selectedAddressForHomeDelivery;
  selectedSubscriptionForHomeDelivery;
  pspSubscriptionStatusEnum: typeof PspSubscriptionStatusEnum = PspSubscriptionStatusEnum;
  flaggingReasonModalRef?: BsModalRef;
  subscriptionHistoryModalRef?: BsModalRef;
  pspCompanyEnum: typeof PspCompanyEnum = PspCompanyEnum;
  uploadFileTypes: string = ".jpg, .jpeg, .png, .gif, .pdf";
  insulinProgram: string = "D-Pen";
  maxFileSize = 10 * 1024 * 1024;

  constructor(
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private patientService: PatientService,
    private router: Router,
    private subscriptionService: PspSubscriptionService,
    private modalNgbService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.subscriptionArray.active = [];
    this.subscriptionArray.pending = [];
    this.subscriptionArray.previous = [];
    this.moreMenuItems.active = {};
    this.moreMenuItems.pending = {};
    this.moreMenuItems.previous = {};

    this.patientService.getPatientPspSubscriptions(this.patientId).subscribe(
      (res) => {
        this.isHaveCareGiverSubscription = res.data.isHaveCareGiverSubscription;
        this.allSubscriptions = res.data.subscriptions;
        this.mapSubscriptionsBasedOnStatusAndPspType(this.allSubscriptions);
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  openNotificationModal(
    modalNotification: TemplateRef<any>,
    editMode = false,
    sub = null
  ): void {
    if (!editMode) {
      this.notificationModal = this.modalService.show(
        modalNotification,
        this.addAddressForm
      );
    } else {
      // this.newAddress = address;
      // this.onCityChange(address.cityId);
      this.notificationModal = this.modalService.show(
        modalNotification,
        this.addAddressForm
      );
      // this.editMode = true;
      this.selectedSubscriptionForHomeDelivery = sub;
      if (this.addresses.length == 0) {
        this.onAddNewAddress();
      }
    }
  }

  onChange(event: any): void {
    this.selectedAddressForHomeDelivery = event;
  }

  onSubmit(form: any): void {
    const body = {
      subscriptionId: this.selectedSubscriptionForHomeDelivery.id,
      patientAddressId: this.selectedAddressForHomeDelivery.patientAddressId,
    };

    this.patientService.addMedicationRequest(body).subscribe((res) => {
      this.notificationModal.hide();
      showNotification('success', 'Added Successfully', this.toastr);
    });
  }

  onAddNewAddress(): void {
    this.addNewAddress.emit();
  }

  openMenuItem(key, index): void {
    Object.keys(this.moreMenuItems[key]).forEach((item) => {
      this.moreMenuItems[key][item] = item == index ? !this.moreMenuItems[key][index] : false;
    });
  }

  requestHomeDelivery(subscription: PatientSubscription, homeOrPickup: string): void {

    if (homeOrPickup === 'home'
      && subscription.program.name === this.insulinProgram) {
        showNotification(
          'danger',
          'You can not request home delivery for insulin program',
          this.toastr
      );

      return;
    }

    if (subscription.statusId === PspSubscriptionStatusEnum.Suspended) {
      showNotification(
          'danger',
          'This patient is flagged that he/she is non-authorized for medication request, please go back to his/her profile to check the data.',
          this.toastr
      );

      return;
    }

    this.patientService.patientAddresses = this.addresses;
    this.patientService.selectedSubscription = subscription;
    if (homeOrPickup == 'home') {
      this.router.navigate(['/request-home-delivery', this.patientId, subscription.id]);
    } else {
      this.router.navigate(['/request-pickup', this.patientId, subscription.id]);
    }
  }

  viewOrEditSubscription(subscription: PatientSubscription): void {
    this.patientService.selectedSubscription = subscription;

    this.router.navigate(['/view-edit-subscription', this.patientId, subscription.id]);
  }

  mapSubscriptionsBasedOnStatusAndPspType(subscriptions: PatientSubscription[]): void{
    this.subscriptionArray.pending = [];
    this.subscriptionArray.active = [];
    this.subscriptionArray.previous = [];

    subscriptions
      .filter((s) => s.typeId === this.currentPspType)
      .forEach((subscription) => {
        switch (subscription.statusId) {
          case PspSubscriptionStatusEnum.Pending:
            this.subscriptionArray.pending.push(subscription);
            break;
          case PspSubscriptionStatusEnum.Active:
          case PspSubscriptionStatusEnum.Suspended:
            this.subscriptionArray.active.push(subscription);
            break;
          default:
            this.subscriptionArray.previous.push(subscription);
        }
      });

    Object.keys(this.subscriptionArray).forEach((key) => {
      this.subscriptionArray[key].map((subscription, index) => {
        this.moreMenuItems[key][index] = false;
      });
    });
  }

  switchPspType(pspType: PspTypeEnum): void{
    this.currentPspType = pspType;
    this.mapSubscriptionsBasedOnStatusAndPspType(this.allSubscriptions);
    window.scrollTo(0,0);
  }
  
  showRocheFields(companyId: number): boolean {
    return companyId === PspCompanyEnum.Roche;
  }

  openFlaggingReasonModal(subscription: PatientSubscription): void {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        actionLabel: subscription.statusId === PspSubscriptionStatusEnum.Active ? 'Flagging' : 'UnFlagging',
      },
    };

    this.flaggingReasonModalRef = this.modalService.show(FlagSubscriptionModalComponent, initialState);

    this.flaggingReasonModalRef.content.event.subscribe((flaggingReasonResponse: any) => {
        this.flaggingReasonModalRef.hide();

        const newStatusId = subscription.statusId === PspSubscriptionStatusEnum.Active
            ? PspSubscriptionStatusEnum.Suspended
            : PspSubscriptionStatusEnum.Active;

        const response = this.subscriptionService.updateSubscriptionStatus(
            subscription.statusId,
            newStatusId,
            subscription.id,
            flaggingReasonResponse.flaggingReason
        );

        response.subscribe((res: any) => {
            if (res.data.flag) {
                showNotification('success', 'The subscription has been changed successfully.', this.toastr);
                this.ngOnInit();
            }
            else{
              showNotification('danger', res.errorList[0].message, this.toastr);
            }
        });
    });
  }

  openSubscriptionHistoryModal(subscription: PatientSubscription): void {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        subscriptionHistory: subscription.subscriptionHistory
      },
    };

    this.subscriptionHistoryModalRef = this.modalService.show(SubscriptionHistoryModalComponent, initialState);

    this.subscriptionHistoryModalRef.content.event.subscribe((history: string) => {
        this.subscriptionHistoryModalRef.hide();

        const response = this.subscriptionService.updateSubscriptionHistory(
            subscription.id,
            history
        );

        response.subscribe((res: any) => {
            if (res.data.flag) {
                showNotification('success', res.message, this.toastr);
                this.ngOnInit();
            }
            else{
              showNotification('danger', res.errorList[0].message, this.toastr);
            }
        });
    });
  }

  isArabic(text: string): boolean {
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    const EnglishRegex = /^[a-zA-Z]+$/;
    for (var i = 0; i < text?.length; i++) 
    {
      if (arabicRegex.test(text[i])) 
      {
        return true;
      }
      else if (EnglishRegex.test(text[i])) 
      {
        return false;
      }
    }
    return false;
  }

  uploadDocument(subscriptionId: number): void {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      backdrop: 'static',
      initialState: {
        acceptedFileTypes: this.uploadFileTypes,
        maxFileSize: this.maxFileSize,
        isSubscriptionDocument: true,
        isHaveContent: true,
        title: 'Upload Subscription Documents'
      }
    };

    const modalRef = this.modalService.show(
      UploadMultipleFilesModalComponent,
      initialState
    );
    
    modalRef.content.uploadFiles.subscribe((files) => {
      const formData = new FormData();
      formData.append('subscriptionId', subscriptionId?.toString() || '');

      for (let i = 0; i < files?.filesToUpload?.length; i++) {
        formData.append('Files', files.filesToUpload[i]);
      }

      this.patientService.uploadSubscriptionDocuments(formData).subscribe(
        (res) => {
          showNotification('success', 'Documents uploaded Successfully', this.toastr);
        },
        (err) => {
          this.spinner.hide();
        }
      );

    });

  }

  previewDocument(subscriptionId: number): void {
    this.patientService.getSubscriptionDocuments(subscriptionId).subscribe(
      (res) => {
        const modalRef = this.modalNgbService.open(PreviewDocumentsModalComponent);
        modalRef.componentInstance.filesUrls = res.data;
      },
      (err) => {
        this.spinner.hide();
      }
    );

  }
}
